import {singleton} from 'tsyringe';
import {FormProxy} from "./form.proxy";

@singleton()
export class ProxyService<TValue extends Record<string, any> = any> {

    private proxyObjects: Map<string, Promise<FormProxy<TValue>>> = new Map();

    public register(uuid: string, proxyObject: Promise<FormProxy<TValue>>): void {
        this.proxyObjects.set(uuid, proxyObject);
    }

    public get(uuid: string): Promise<FormProxy<TValue>> | null {
        return this.proxyObjects.get(uuid) ?? null;
    }

    public has(uid: string): boolean {
        return this.proxyObjects.has(uid);
    }

    public commit(uuid: string): void {
        if (this.proxyObjects.has(uuid)) {
            this.proxyObjects.get(uuid)!.then(form => form.commit());
        }
    }

    public delete(uuid: string): void {
        if (this.proxyObjects.has(uuid)) {
            this.proxyObjects.delete(uuid);
        }
    }
}